import { S1Referral } from '@doc-abode/data-models';

import { formatDisplayDateTime } from '../../components/modules/helpers/formatData';

export const formatS1ReferralName = (referral: S1Referral) => {
    const { ReferralDate, Service, Reason } = referral;
    return `${formatDisplayDateTime(ReferralDate)} - ${Service} for ${Reason}`;
};
